export function sanitizeSheetName(name) {
    return name.replace(/[\\/*?:\[\]]/g, '').substring(0, 31);
  }
  
  export function styleHeader(cell) {
    cell.font = { 
      bold: true, 
      size: 12, 
      color: { argb: 'FFFFFFFF' }, 
      name: 'Calibri Light'
    };
    cell.fill = {
      type: 'pattern', 
      pattern: 'solid', 
      fgColor: { argb: 'FF4F81BD' } // Rich blue
    };
    styleBorders(cell, 'thick');  // Changed to thick for bold borders
    cell.alignment = { 
      wrapText: true, 
      vertical: 'middle', 
      horizontal: 'center' 
    };
  }
  
  export function styleCell(cell) {
    cell.font = { 
      name: 'Calibri', 
      size: 10,
      color: { argb: 'FF444444' } // Dark gray for better readability
    };
    // Alternate row coloring for better visibility
    if (cell.row.number % 2 === 0) {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFF2F2F2' } // Very light gray
      };
    } else {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFFFF' } // White
      };
    }
    styleBorders(cell, 'thick');  // Changed to thick for bold borders
  }
  
  export function styleBorders(cell, style) {
    cell.border = {
      top: { style, color: { argb: 'FFD0CECE' } }, // Light gray
      bottom: { style, color: { argb: 'FFD0CECE' } },
      left: { style, color: { argb: 'FFD0CECE' } },
      right: { style, color: { argb: 'FFD0CECE' } },
    };
  }
  
  // Additional styling function for category headers
  export function styleCategoryHeader(cell) {
    cell.font = { 
      bold: true, 
      italic: true,
      size: 11, 
      color: { argb: 'FFE84C3D' }, // Vibrant red
      name: 'Calibri'
    };
    cell.fill = {
      type: 'pattern', 
      pattern: 'solid', 
      fgColor: { argb: 'FFFDE7E6' } // Very light pink/red
    };
    cell.border = {
      top: { style: 'thick', color: { argb: 'FFE84C3D' } },  // Changed to thick
      bottom: { style: 'thick', color: { argb: 'FFE84C3D' } }, // Changed to thick
      left: { style: 'thick', color: { argb: 'FFE84C3D' } },  // Changed to thick
      right: { style: 'thick', color: { argb: 'FFE84C3D' } }, // Changed to thick
    };
    cell.alignment = { 
      wrapText: true, 
      vertical: 'middle', 
      horizontal: 'center' 
    };
  }
  
  // Additional styling function for important cells (totals, etc.)
  export function styleImportantCell(cell) {
    cell.font = { 
      bold: true, 
      size: 11, 
      color: { argb: 'FF2C3E50' }, // Dark blue-gray
      name: 'Calibri'
    };
    cell.fill = {
      type: 'pattern', 
      pattern: 'solid', 
      fgColor: { argb: 'FFD4E6F1' } // Light blue
    };
    cell.border = {
      top: { style: 'thick', color: { argb: 'FF3498DB' } },  // Changed to thick
      bottom: { style: 'thick', color: { argb: 'FF3498DB' } }, // Changed to thick
      left: { style: 'thick', color: { argb: 'FF3498DB' } },  // Changed to thick
      right: { style: 'thick', color: { argb: 'FF3498DB' } }, // Changed to thick
    };
  }
  export const styleRow = (row, isHeader = false, isTotal = false, isCategory = false) => {
    row.height = isHeader ? 50 : (isCategory ? 20 : 45); // Set height to 20 for category rows
    row.eachCell(cell => {
      if (isHeader) {
        styleHeader(cell);
      } else if (isTotal) {
        cell.font = { bold: true, color: { argb: 'FF2A4E7F' } };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFD9E1F2' },
        };
        styleBorders(cell, 'medium');
      } else if (isCategory) {
        cell.font = { bold: true, color: { argb: 'FF2A4E7F' } }; // Optional styling for category rows
      } else {
        styleCell(cell);
      }
      cell.alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
    });
  };
  
  // Reusable function to format currency columns
  export const formatCurrencyColumns = (sheet, columns, startRow = 2) => {
    columns.forEach(col => {
      for (let i = startRow; i <= sheet.lastRow.number; i++) {
        const cell = sheet.getCell(`${col}${i}`);
        if (cell.value !== null && cell.value !== undefined) {
          cell.numFmt = '"₹"#,##0.00';
        }
      }
    });
  };
  

  export async function getBase64FromLocalImage(path) {
    const response = await fetch(path);
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result.split(',')[1];
        resolve(base64data);
      };
    });
  }

// utils/watermark.js
export const addWatermarkToSheet = (workbook, sheet, base64Logo, options = {}) => {
    const {
      width = 600,
      height = 300,
      col = 1,
      row = 1,
    } = options;
  
    const imageId = workbook.addImage({
      base64: base64Logo,
      extension: 'png',
    });
  
    sheet.addImage(imageId, {
      tl: { col, row },
      ext: { width, height },
      editAs: 'oneCell', // or 'absolute' for fixed position
    });
  };
  